import React from 'react';
import { PLES, getPLELogo } from './plesDatabase';
import { getPLEBg } from './pleThemes';

import bgRaw from '../assets/brands/backgrounds/RAW25_BACKGROUND.png';
import bgSmackDown from '../assets/brands/backgrounds/SMACKDOWN25_BACKGROUND.png';
import bgNXT from '../assets/brands/backgrounds/NXT_BACKGROUND.png';
import bgNXT20 from '../assets/brands/backgrounds/NXT20_BACKGROUND.png';
import bgWCW from '../assets/brands/backgrounds/WCW_BACKGROUND.png';
import bgECW from '../assets/brands/backgrounds/ECW_BACKGROUND.png';
import bgNXTMutiny from '../assets/brands/backgrounds/NXTMUTINY_BACKGROUND.png';

import gmAdamPearce from '../assets/gm/94400_ADAM_PEARCE.png';
import gmNickAldis from '../assets/gm/121300_NICK_ALDIS.png';
import gmShawnMichaels from '../assets/gm/45750_SHAWN_MICHAELS.png';
import gmAva from '../assets/gm/121400_AVA.png';
import gmStephanie from '../assets/gm/14700_STEPHANIE_MCMAHON.png';
import gmPaulHeyman from '../assets/gm/37410_PAUL_HEYMAN_14.png';
import gmWilliamRegal from '../assets/gm/94010_WILLIAM_REGAL.png';
import gmMickFoley from '../assets/gm/14400_MICK_FOLEY.png';
import gmTeddyLong from '../assets/gm/28600_TEDDY_LONG.png';
import gmEricBischoff from '../assets/gm/93900_ERIC_BISCHOFF.png';
import gmSherri from '../assets/gm/42850_SENSATIONAL_SHERRI.png';
import gmMissElizabeth from '../assets/gm/23450_MISS_ELIZABETH.png';
import gmMrFuji from '../assets/gm/130250_MR_FUJI.png';
import gmBobbyHeenan from '../assets/gm/24900_BOBBY_HENNAN.png';
import gmCMPunk from '../assets/gm/31250_CM_PUNK.png';
import gmXavierWoods from '../assets/gm/42030_XAVIER_WOODS.png';
import gmTylerBreeze from '../assets/gm/58110_TYLER_BREEZE.png';
import gmStacyKeibler from '../assets/gm/148600_STACY_KEIBLER_GM.png';
import gmAnonymousGM from '../assets/gm/149100_ANONYMOUS_GM.png';

import logoRaw from '../assets/brands/logos/RAW25_LOGO.png';
import logoSmackDown from '../assets/brands/logos/SMACKDOWN25_LOGO.png';
import logoNXT from '../assets/brands/logos/NXT_LOGO.png';
import logoNXT20 from '../assets/brands/logos/NXT20_LOGO.png';
import logoWCW from '../assets/brands/logos/WCW_LOGO.png';
import logoECW from '../assets/brands/logos/ECW_LOGO.png';
import logoNXTMutiny from '../assets/brands/logos/NXTMUTINY_LOGO.png';

import placeholder from '../assets/placeholder.png';

const GM_RENDERS = {
  'Adam Pearce': gmAdamPearce, 'Nick Aldis': gmNickAldis, 'Shawn Michaels': gmShawnMichaels,
  'Ava': gmAva, 'Stephanie McMahon': gmStephanie, 'Paul Heyman': gmPaulHeyman,
  'William Regal': gmWilliamRegal, 'Mick Foley': gmMickFoley, 'Teddy Long': gmTeddyLong,
  'Eric Bischoff': gmEricBischoff, 'Sensational Sherri': gmSherri, 'Miss Elizabeth': gmMissElizabeth,
  'Mr Fuji': gmMrFuji, 'Bobby Heenan': gmBobbyHeenan, 'CM Punk': gmCMPunk,
  'Xavier Woods': gmXavierWoods, 'Tyler Breeze': gmTylerBreeze, 'Stacy Keibler': gmStacyKeibler,
  'Anonymous GM': gmAnonymousGM,
};

const BRAND_LOGOS = {
  'Raw': logoRaw, 'SmackDown': logoSmackDown, 'NXT': logoNXT,
  'NXT 2.0': logoNXT20, 'WCW': logoWCW, 'ECW': logoECW, 'NXT Mutiny': logoNXTMutiny,
};
const BRAND_COLORS = {
  'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#a8a9ad',
  'NXT 2.0': '#e91e8c', 'ECW': '#7b1fa2', 'WCW': '#e65100', 'NXT Mutiny': '#424242',
};
const BRAND_BGS = {
  'Raw': bgRaw, 'SmackDown': bgSmackDown, 'NXT': bgNXT,
  'NXT 2.0': bgNXT20, 'WCW': bgWCW, 'ECW': bgECW, 'NXT Mutiny': bgNXTMutiny,
};

const AUTO_FAN_THRESHOLDS = [2300000, 3400000, 4500000, 5250000, 6000000];
const AUTO_PROFIT_THRESHOLDS = [2000000, 5250000, 8750000, 12500000, 16000000];

const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .wb-enter-btn:hover { background: rgba(212,175,55,0.22) !important; border-color: rgba(212,175,55,0.8) !important; }
  @keyframes wbFadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
  .wb-fade { animation: wbFadeIn 0.28s ease both; }
`;

const S = {
  anton: { fontFamily: "'Anton', sans-serif" },
  mono: { fontFamily: "'Monda', sans-serif" },
  panel: { background: 'rgba(8,8,8,0.96)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px' },
};

const formatFans = (val) => {
  if (val === undefined || val === null) return '0';
  return Math.round(Number(val)).toLocaleString('fr-FR');
};

const calcRivalHof = (r) => {
  var rHofActive = r.hofActive || [];
  var rFans = r.fans || 0;
  var rProfits = r.totalProfits || 0;
  var rAutoFan = AUTO_FAN_THRESHOLDS.filter(function(t) { return rFans >= t; }).length;
  var rAutoProfit = AUTO_PROFIT_THRESHOLDS.filter(function(t) { return rProfits >= t; }).length;
  return rHofActive.length + rAutoFan + rAutoProfit;
};

export default function WelcomeBackPopup({ gameData, onEnter }) {
  if (!gameData) return null;

  var gm = gameData.gm || '';
  var brand = gameData.brand || '';
  var season = gameData.season || 1;
  var week = gameData.week || 1;
  var fans = gameData.fans || 0;
  var rivals = (gameData.rivals || []).filter(Boolean);
  var victoryCriteria = gameData.victoryCriteria || gameData.gameSettingsData?.victoryCriteria || 'fans';
  var nextPle = gameData.nextPle || null;

  var hofActive = gameData.hofActive || [];
  var totalProfits = (gameData.seasonHistory || []).reduce(function(s, w) { return s + (w.profits || 0); }, 0);
  var autoFan = AUTO_FAN_THRESHOLDS.filter(function(t) { return fans >= t; }).length;
  var autoProfit = AUTO_PROFIT_THRESHOLDS.filter(function(t) { return totalProfits >= t; }).length;
  var myHof = hofActive.length + autoFan + autoProfit;

  var gmRender = gameData.gmRender || GM_RENDERS[gm] || null;
  var brandLogo = gameData.brandLogo || BRAND_LOGOS[brand] || null;
  var brandColor = gameData.brandColor || BRAND_COLORS[brand] || '#d4af37';

  // Build standings — same logic as Dashboard
  var entries = [
    {
      isPlayer: true, gm: gm, brand: brand,
      logo: brandLogo, color: brandColor,
      fans: fans, trophies: myHof,
      value: victoryCriteria === 'fans' ? fans : myHof,
    },
    ...rivals.map(function(r) {
      var rFans = r.fans || 0;
      var rTrophies = calcRivalHof(r);
      return {
        isPlayer: false, gm: r.gm || '—', brand: r.brand || '',
        logo: BRAND_LOGOS[r.brand] || r.brandLogo || null,
        color: BRAND_COLORS[r.brand] || r.brandColor || '#444',
        fans: rFans, trophies: rTrophies,
        value: victoryCriteria === 'fans' ? rFans : rTrophies,
      };
    }),
  ].sort(function(a, b) {
    var primary = b.value - a.value;
    if (primary !== 0) return primary;
    return victoryCriteria === 'fans' ? (b.trophies - a.trophies) : (b.fans - a.fans);
  });

  // PLE info
  var pleObj = nextPle ? PLES.find(function(p) { return p.id === nextPle; }) : null;
  var pleLogo = pleObj ? getPLELogo(pleObj.id) : null;
  var pleBgUrl = pleObj ? getPLEBg(pleObj.id) : null;
  // Find which week the next PLE falls on
  var nextPleWeek = Math.ceil(week / 5) * 5;
  if (nextPleWeek < week) nextPleWeek += 5;


  var rankColors = ['#d4af37', '#95a5a6', '#e67e22', '#888888'];

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.88)' }}>
      <style>{css}</style>
      <div className="wb-fade" style={{ ...S.panel, width: '100%', maxWidth: '680px', overflow: 'hidden', margin: '0 16px' }}>

        {/* Gold top bar */}
        <div style={{ height: '4px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />

        {/* Header — GM render + brand + meta */}
        <div style={{ padding: '22px 24px 18px', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', gap: '18px' }}>
          {/* GM render */}
          <div style={{ width: '80px', height: '104px', flexShrink: 0, position: 'relative', overflow: 'hidden' }}>
            <img
              loading="lazy"
              src={gmRender || placeholder}
              alt={gm}
              style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', height: '112px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.9))' }}
              onError={function(e) { e.target.src = placeholder; }}
            />
          </div>

          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ ...S.mono, fontSize: '0.49rem', color: 'rgba(255,255,255,0.25)', letterSpacing: '2px', marginBottom: '4px' }}>WELCOME BACK</div>
            <div style={{ ...S.anton, fontSize: '1.3rem', color: '#fff', letterSpacing: '1px', lineHeight: 1 }}>{gm.toUpperCase()}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
              {brandLogo
                ? <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '24px', objectFit: 'contain', filter: 'drop-shadow(0 1px 4px rgba(0,0,0,0.8))' }} onError={function(e) { e.target.style.display='none'; }} />
                : <div style={{ ...S.anton, fontSize: '0.72rem', color: brandColor, letterSpacing: '1px' }}>{brand.toUpperCase()}</div>
              }
              <div style={{ ...S.mono, fontSize: '0.49rem', color: 'rgba(255,255,255,0.25)', letterSpacing: '1px' }}>SEASON {season} · WEEK {week}</div>
            </div>
          </div>

          {/* My key stats */}
          <div style={{ textAlign: 'right', flexShrink: 0 }}>
            <div style={{ ...S.mono, fontSize: '0.44rem', color: 'rgba(255,255,255,0.25)', letterSpacing: '1px', marginBottom: '2px' }}>FANS</div>
            <div style={{ ...S.anton, fontSize: '1.1rem', color: '#fff', letterSpacing: '1px' }}>{formatFans(fans)}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'flex-end', marginTop: '6px' }}>
              <img loading="lazy" src={process.env.PUBLIC_URL + '/hof/trophy.png'} alt="HOF" style={{ width: '18px', height: '18px', objectFit: 'contain' }} onError={function(e) { e.target.style.display='none'; }} />
              <div style={{ ...S.anton, fontSize: '1.1rem', color: '#d4af37', letterSpacing: '1px' }}>{myHof}</div>
              <div style={{ ...S.mono, fontSize: '0.44rem', color: 'rgba(212,175,55,0.4)', letterSpacing: '1px' }}>HOF</div>
            </div>
          </div>
        </div>

        {/* Standings */}
        <div style={{ padding: '16px 24px 10px' }}>
          <div style={{ ...S.mono, fontSize: '0.49rem', color: 'rgba(255,255,255,0.22)', letterSpacing: '2px', marginBottom: '9px' }}>
            STANDINGS · {victoryCriteria === 'fans' ? 'BASED ON FANS' : 'BASED ON HOF TROPHIES'}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
            {entries.map(function(entry, rank) {
              var rankColor = rankColors[rank] || 'rgba(255,255,255,0.25)';
              var isPlayer = entry.isPlayer;
              var entryBrandBg = BRAND_BGS[entry.brand] || null;
              return (
                <div key={rank} style={{
                  padding: '11px 14px',
                  display: 'flex', alignItems: 'center', gap: '12px',
                  borderRadius: '7px',
                  border: '1px solid ' + (isPlayer ? entry.color + '40' : 'rgba(255,255,255,0.06)'),
                  background: 'transparent',
                  position: 'relative', overflow: 'hidden',
                }}>
                  {/* Brand background */}
                  {entryBrandBg && (
                    <div style={{
                      position: 'absolute', inset: 0,
                      backgroundImage: 'url(' + entryBrandBg + ')',
                      backgroundSize: 'cover', backgroundPosition: 'center',
                      opacity: isPlayer ? 0.18 : 0.09,
                      pointerEvents: 'none',
                    }} />
                  )}
                  {/* Rank */}
                  <div style={{ ...S.anton, fontSize: '1.1rem', color: rankColor, width: '16px', textAlign: 'center', flexShrink: 0, position: 'relative' }}>{rank + 1}</div>

                  {/* Brand logo + GM name */}
                  <div style={{ flex: 1, minWidth: 0, position: 'relative' }}>
                    {entry.logo
                      ? <img loading="lazy" src={entry.logo} alt={entry.brand} style={{ height: '26px', objectFit: 'contain', display: 'block', marginBottom: '3px' }} onError={function(e) { e.target.style.display='none'; }} />
                      : <div style={{ ...S.anton, fontSize: '0.72rem', color: entry.color, letterSpacing: '1px', marginBottom: '2px' }}>{(entry.brand || '').toUpperCase()}</div>
                    }
                    <div style={{ ...S.mono, fontSize: '0.62rem', color: isPlayer ? 'rgba(255,255,255,0.75)' : 'rgba(255,255,255,0.4)', letterSpacing: '0.5px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{entry.gm}</div>
                  </div>

                  {/* Stats — primary large, secondary small */}
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px', flexShrink: 0, position: 'relative' }}>
                    {/* Fans */}
                    <div style={{ opacity: victoryCriteria === 'fans' ? 1 : 0.35 }}>
                      <div style={{ ...S.anton, fontSize: victoryCriteria === 'fans' ? '0.8rem' : '0.55rem', color: '#fff', letterSpacing: '0.5px' }}>{formatFans(entry.fans)}</div>
                      {victoryCriteria === 'fans' && <div style={{ ...S.mono, fontSize: '0.42rem', color: 'rgba(255,255,255,0.25)', letterSpacing: '1px', textAlign: 'right' }}>FANS</div>}
                    </div>
                    {/* HOF */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '3px', opacity: victoryCriteria !== 'fans' ? 1 : 0.35 }}>
                      <img loading="lazy" src={process.env.PUBLIC_URL + '/hof/trophy.png'} alt="" style={{ width: '9px', height: '9px', objectFit: 'contain', opacity: victoryCriteria !== 'fans' ? 1 : 0.5 }} onError={function(e) { e.target.style.display='none'; }} />
                      <div style={{ ...S.anton, fontSize: victoryCriteria !== 'fans' ? '0.8rem' : '0.55rem', color: '#d4af37', letterSpacing: '0.5px' }}>{entry.trophies}</div>
                      {victoryCriteria !== 'fans' && <div style={{ ...S.mono, fontSize: '0.42rem', color: 'rgba(212,175,55,0.35)', letterSpacing: '1px' }}>HOF</div>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Next PLE */}
        {pleObj && (
          <div style={{ margin: '6px 24px 10px', borderRadius: '7px', border: '1px solid rgba(255,255,255,0.06)', overflow: 'hidden', position: 'relative' }}>
            {/* PLE background */}
            {pleBgUrl && (
              <div style={{
                position: 'absolute', inset: 0,
                backgroundImage: 'url(' + pleBgUrl + ')',
                backgroundSize: 'cover', backgroundPosition: 'center',
                opacity: 0.2,
                pointerEvents: 'none',
              }} />
            )}
            <div style={{ position: 'relative', padding: '11px 16px', display: 'flex', alignItems: 'center', gap: '14px' }}>
              <img
                loading="lazy"
                src={pleLogo}
                alt={pleObj.name}
                style={{ height: '42px', objectFit: 'contain', filter: 'drop-shadow(0 1px 4px rgba(0,0,0,0.8))' }}
                onError={function(e) { e.target.style.display='none'; }}
              />
              <div>
                <div style={{ ...S.mono, fontSize: '0.44rem', color: 'rgba(255,255,255,0.22)', letterSpacing: '1px' }}>NEXT PLE</div>
                <div style={{ ...S.anton, fontSize: '0.85rem', color: 'rgba(255,255,255,0.65)', letterSpacing: '1px' }}>{pleObj.name.toUpperCase()} · WEEK {nextPleWeek}</div>
              </div>
            </div>
          </div>
        )}

        {/* CTA */}
        <div style={{ padding: '12px 24px 20px' }}>
          <button
            className="wb-enter-btn"
            onClick={onEnter}
            style={{
              width: '100%',
              ...S.anton,
              fontSize: '0.75rem',
              letterSpacing: '2px',
              background: 'rgba(212,175,55,0.1)',
              border: '1px solid rgba(212,175,55,0.4)',
              color: '#d4af37',
              padding: '15px',
              borderRadius: '7px',
              cursor: 'pointer',
              transition: 'background 0.15s, border-color 0.15s',
            }}
          >
            ENTER WEEK {week}
          </button>
        </div>

      </div>
    </div>
  );
}
